<!--运营中心 - 清洗记录-->
<template>
  <div>

    <div class="search">
      <el-form :inline="true" style="padding-top:0px;margin-top:0px" :model="searchForm" class="searchForm"
        size="medium">

        <el-form-item prop="date1" label="消洗日期:">
          <el-date-picker type="date" size="medium" placeholder="选择日期" v-model="searchForm.date1" style="width:200px;"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-row style="padding-top:10px;padding-bottom:10px">
          <el-button size="medium" @click="serch()" type="primary">筛选</el-button>
          <el-button type="text" size="medium" style="color: #409EFF" @click="clearSearch()">重置筛选条件</el-button>
        </el-row>
      </el-form>
    </div>
    <el-row class="middle">
      <!-- <el-button size="medium" @click="batchReport()" type="primary" >批量上报</el-button> -->
      <el-button size="medium" @click="addDish()" type="primary">新增消洗记录</el-button>
      <el-button size="medium" @click="clearingProtect()" type="primary">消毒方式维护</el-button>
      <el-button size="medium" @click="clearingParameter()" type="primary">消毒参数维护</el-button>
      <el-button size="medium" @click="clearingArea()" type="primary">区域管理</el-button>
    </el-row>
    <el-row style="padding: 15px 20px;background:white;border-radius:3px">

      <el-table stripe border :data="tableData" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="消洗类型" prop="RECORD_DATA.DISINFECTION_TYPE">
          <template slot-scope="scope">
            <el-tag>{{ showStatus1[scope.row.RECORD_DATA.DISINFECTION_TYPE] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否全部消毒" prop="RECORD_DATA.IS_ALL_STERILIZED">
          <template slot-scope="scope">
            <el-tag>{{ showStatus[scope.row.RECORD_DATA.IS_ALL_STERILIZED] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="区域名称" prop="RECORD_DATA.REGION_NAME"></el-table-column>
        <el-table-column label="物品名称" prop="RECORD_DATA.ITEM_NAME"></el-table-column>
        <el-table-column label="消洗方式" width="200">
          <template slot-scope="scope">
            <span v-for="meal in scope.row.DETAIL_DATA" :key="meal.index">{{ meal.DM_NAME + '——' + meal.DP_NAME
            }}&nbsp;&nbsp; <br></span>
          </template>
        </el-table-column>
        <el-table-column label="消洗时间" prop="RECORD_DATA.DISINFECT_TIME"></el-table-column>
        <!-- <el-table-column label="上报部门" prop="PROJECT_CODE"></el-table-column> -->
        <el-table-column label="人员姓名" prop="RECORD_DATA.STAFF_MEMBER"></el-table-column>
        <el-table-column label="开始时间" prop="RECORD_DATA.START_TIME"></el-table-column>
        <el-table-column label="时长(分钟)" prop="RECORD_DATA.DURATION"></el-table-column>
        <el-table-column label="操作" prop="PROJECT_NAME" width="200">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="CheckDetail(scope.row)">查看</el-button> -->
            <!-- <el-button type="text" size="small" @click="handleCheckDetail(scope.row)">审核</el-button> -->
            <el-button type="text" size="small" @click="viewImg(scope.row)">相关图片</el-button>
            <el-button type="text" size="small" @click="deleteList(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination style="text-align: right" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </el-row>
    <el-dialog title="新增消洗记录" center :visible.sync="addFormVisible" width="600px">
      <el-form ref="addForm" :model="addForm" :label-width="'150px'" :inline="true" :rules="rules">
        <!-- <el-form-item label="月份:">
                 <label slot="label">月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;份：</label>
                 <el-date-picker style="width:350px"
                         v-model="addForm.MONTH"
                         type="month"
                         value-format="yyyy-MM"
                         placeholder="选择日期" :clearable = 'false'>
                 </el-date-picker>
            </el-form-item> -->

        <el-form-item label="消毒类型：" prop="DISINFECTION_TYPE">
          <el-select filterable v-model="addForm.DISINFECTION_TYPE" placeholder="请选择" style="width:350px">
            <el-option v-for="item in clearingTypes" :key="item.value" :label="item.NAME" :value="item.ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择区域：" prop="RIGION_ID" v-if="this.addForm.DISINFECTION_TYPE == 1">
          <el-select filterable v-model="addForm.RIGION_ID" placeholder="请选择" style="width:350px">
            <el-option v-for="item in areaList" :key="item.value" :label="item.REGION_NAME" :value="item.REGION_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物品名称：" prop="ITEM_NAME" v-else>
          <el-input v-model="addForm.ITEM_NAME" style="width:350px" maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="是否全部消毒：" prop="IS_ALL_STERILIZED">
          <el-radio v-model="addForm.IS_ALL_STERILIZED" label="1">是</el-radio>
          <el-radio v-model="addForm.IS_ALL_STERILIZED" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="消毒方式：" prop="SECOND_TYPE">
          <el-select filterable v-model="addForm.SECOND_TYPE" placeholder="请选择" style="width:350px" multiple
            collapse-tags @change="selectMode">
            <el-option v-for="item in modeList" :key="item.value" :label="item.DM_NAME" :value="item.DM_ID">
              <!-- <span style="float: left">{{ item.NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="红外线消毒：" prop="SECOND_TYPE">
               <el-select filterable v-model="addForm.SECOND_TYPE" placeholder="请选择" style="width:350px" >
                    <el-option v-for="item in secondTypes" :key="item.value" :label="item.SECOND_TYPE_NAME" :value="item.SECOND_TYPE_ID" >

                    </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="高温蒸煮：" prop="SECOND_TYPE">
               <el-select filterable v-model="addForm.SECOND_TYPE" placeholder="请选择" style="width:350px" >
                    <el-option v-for="item in secondTypes" :key="item.value" :label="item.SECOND_TYPE_NAME" :value="item.SECOND_TYPE_ID" >

                    </el-option>
               </el-select>
            </el-form-item> -->
        <div v-for="(item, index) in parameList" :key="item.DM_ID">
          <!-- <el-radio
                v-model="item.longTime"
                label="1"
                style="line-height: 40px; margin-left: 5px"
              >
                长期
              </el-radio> -->
          <el-form-item :label="item.DM_NAME + ':'" prop="SECOND_TYPE1">
            <el-select filterable v-model="addForm.SECOND_PARAM[index]" placeholder="请选择" style="width:350px">
              <el-option v-for="item in item.DP_LIST" :key="item.value" :label="item.DP_NAME" :value="item.DP_ID">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="时长(分钟)：" prop="DURATION">
          <el-input v-model="addForm.DURATION" style="width:350px"></el-input>
        </el-form-item>
        <el-form-item label="开始时间：" required>
          <el-col :span="11">
            <el-form-item prop="date1">
              <el-date-picker type="date" placeholder="选择日期" v-model="addForm.date1" style="width: 157px;"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="date2">
              <el-time-picker placeholder="选择时间" v-model="addForm.date2" style="width: 157px;" value-format="HH:mm">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <!-- <el-date-picker type="date" style="width:350px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="addForm.START_TIME"></el-date-picker> -->
        </el-form-item>
        <el-form-item label="人员：" prop="STAFF_MEMBER">
          <el-input v-model="addForm.STAFF_MEMBER" style="width:350px"></el-input>
        </el-form-item>
        <el-form-item label="相关图片：" prop="PHOTO_URL">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload" list-type="picture"
            :on-success="handleSuccess" :on-remove="handleRemove" :name="addForm.image" :multiple="false" :limit="1"
            accept=".jpg,.jpeg,.bmp,.gif,.png" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取消</el-button>
        <el-button @click="submitContract()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="图片查看" :visible.sync="viewVisible">
      <!-- <div style="  display: flex;justify-content: center;"> -->
      <img :src="viewimg" style="
          margin: 0px auto;
          width: 100%;
          height: 100%;
          border: 2px solid #eee;
        " />
    </el-dialog>
  </div>
</template>

<script>
import date from '@/assets/common/date';
// import util from '@/assets/common/util';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        project: '',
        SECOND_TYPE: '',
        MONTH: date(Date.now(), '%F').slice(0, 7),
      },
      viewimg: '',
      viewVisible: false,
      clearingTypes: [{ NAME: '区域', ID: 1 }, { NAME: '物品', ID: 2 }],
      showStatus: ['否', '是'],
      showStatus1: ['', '区域', '物品'],
      fileList: [],
      file_name: '',
      points: [],
      addFormVisible: false,
      addForm: {
        FIRST_TYPE: 1,
        DISINFECTION_TYPE: '',
        RIGION_ID: '',
        ITEM_NAME: '',
        SECOND_TYPE: [],
        TIME: '',
        SECOND_PARAM: [],
        SECOND_MODE: [],
        START_TIME: '',
        image: 'DisinfectionPhotos',
        STAFF_MEMBER: '',
      },
      rules: {
        DISINFECTION_TYPE: [{ required: true, message: '请输入消毒类型', trigger: 'change' }],
        ITEM_NAME: [{ required: true, message: '请输入消毒区域', trigger: 'change' }],
        RIGION_ID: [{ required: true, message: '请输入消毒区域', trigger: 'blur' }],
        IS_ALL_STERILIZED: [{ required: true, message: '请选择', trigger: 'change' }],
        SECOND_TYPE: [{ required: true, message: '请选择消毒方式', trigger: 'change' }],
        DURATION: [{ required: true, message: '请输入时长', trigger: 'blur' }],
        STAFF_MEMBER: [{ required: true, message: '请输入人员', trigger: 'blur' }],
        START_TIME: [{ required: true, message: '请输入开始时间', trigger: 'change' }],
        PHOTO_URL: [{ required: true, message: '请上传照片', trigger: 'change' }],
        SECOND_TYPE_NAME: [{ required: true, message: '请输入二级类别', trigger: 'blur' }],
        REPORT_FEE: [{ required: true, message: '请输入金额', trigger: 'blur' }],
      },
      formLabelWidth: '120px',
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      total_count: 0,
      loading1: false,
      secondTypes: [],
      areaList: [],
      parameList: [],
      modeList: [],
      modeParam: [],
      METHOND_PARAMETERS_LIST: [],
    };
  },
  computed: {
  },
  created() {
    this.queryList();
    this.queryAreaList();
    this.queryClearMode();
  },
  methods: {
    clearSearch() {
      this.searchForm = {
        MONTH: date(Date.now(), '%F').slice(0, 7),
      };
    },
    changeSecondType() {

    },

    // 新增上传图片
    handleSuccess(response, file, fileList) {
      this.file_name = response.base_url + response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    // 消毒方式维护
    clearingProtect() {
      this.$router.push({ path: '/clearing/detail' });
    },
    clearingParameter() {
      this.$router.push({ path: '/clearingParameter/detail' });
    },
    clearingArea() {
      this.$router.push({ path: '/clearingArea/detail' });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    serch() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 24,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        CLIENT_TYPE: 2,
        CLIENT_ID: sessionStorage.getItem('tcId'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.date1) {
        params.DISINFECT_TIME = this.searchForm.date1;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.total_count = result[0].TOTAL_COUNT;
          this.tableData = result[0].LIST;
        } else {
          this.total_count = 0;
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addDish() {
      this.addFormVisible = true;
    },
    selectMode(e) {
      this.parameList = [];
      this.modeParam = e;
      if (e.length !== 0) {
        this.queryParame(e);
      } else {
        this.parameList = [];
      }
    },
    queryParame(e) {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 22,
        CLIENT_TYPE: 2,
        CLIENT_ID: sessionStorage.getItem('tcId'),
        DM_ID_LIST: e,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        this.addForm.SECOND_PARAM = [];
        this.parameList = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    submitContract() {
      this.METHOND_PARAMETERS_LIST = [];
      const METHOND_PARAMETERS_LIST = this.modeParam.map((item, index) => ({ DM_ID: item, DP_ID: this.addForm.SECOND_PARAM[index] }));
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11011',
            OTYPE: 23,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            CLIENT_TYPE: 2,
            CLIENT_ID: sessionStorage.getItem('tcId'),
            DISINFECTION_TYPE: this.addForm.DISINFECTION_TYPE,

            METHOND_PARAMETERS_LIST,
            IS_ALL_STERILIZED: this.addForm.IS_ALL_STERILIZED,
            START_TIME: `${this.addForm.date1} ${this.addForm.date2}`,
            STAFF_MEMBER: this.addForm.STAFF_MEMBER,
            DURATION: this.addForm.DURATION,
            PHOTO_URL: this.file_name,
          };
          if (this.addForm.DISINFECTION_TYPE == 1) {
            params.RIGION_ID = this.addForm.RIGION_ID;
            if (!this.addForm.RIGION_ID) {
              this.$message.show({ text: '请选择区域', type: 'warning' });
              document.body.style.cursor = 'default';
              return false;
            }
          } else {
            params.ITEM_NAME = this.addForm.ITEM_NAME;
            if (!this.addForm.ITEM_NAME) {
              this.$message.show({ text: '请填写物品名称', type: 'warning' });
              document.body.style.cursor = 'default';
              return false;
            }
          }
          if (!this.addForm.DISINFECTION_TYPE) {
            this.$message.show({ text: '请选择消毒类型', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!this.addForm.DURATION) {
            this.$message.show({ text: '请填写消毒时长', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.addForm.DURATION)) {
            this.$message.show({ text: '请输入正确的时长', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }


          if (!this.addForm.STAFF_MEMBER) {
            this.$message.show({ text: '请填写操作人员', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!this.file_name) {
            this.$message.show({ text: '请上传图片', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!this.addForm.date1 || !this.addForm.date2) {
            this.$message.show({ text: '请填写完整的开始时间', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (this.addForm.SECOND_TYPE.length == 0) {
            this.$message.show({ text: '请选择消毒方式', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.file_name = '';
            this.addForm = {
              FIRST_TYPE: 1,
              DISINFECTION_TYPE: '',
              RIGION_ID_LIST: [],
              ITEM_NAME: '',
              SECOND_TYPE: [],
              TIME: '',
              SECOND_PARAM: [],
              SECOND_MODE: [],
              START_TIME: '',
              image: 'DisinfectionPhotos',
              STAFF_MEMBER: '',
            };
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    viewImg(row) {
      //   this.viewVisible = true
      if (row.RECORD_DATA.PHOTO_URL == '' || !row.RECORD_DATA.PHOTO_URL) {
        this.$message.show({ text: '暂无图片', type: 'success' });
      } else {
        this.viewimg = row.RECORD_DATA.PHOTO_URL;
        this.viewVisible = true;
      }
    },
    close() {
      this.addFormVisible = false;
    },
    // 删除
    deleteList(row) {
      this.$confirm('您确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '11011',
          OTYPE: 25,
          RECORD_ID: row.RECORD_DATA.RECORD_ID,

          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    queryAreaList() {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 20,
        CLIENT_TYPE: 2,
        CLIENT_ID: sessionStorage.getItem('tcId'),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        this.areaList = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    queryClearMode() {
      const params = {
        SERVICE_ID: '11011',
        OTYPE: 21,
        CLIENT_TYPE: 2,
        CLIENT_ID: sessionStorage.getItem('tcId'),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((result) => {
        this.modeList = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },

  },
};

</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}

.qualificatLoad {
  font-size: 14px;
  color: #606266;
}

.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 40px;
  margin: 0 -20px 0 -20px;
}

.search {
  width: 100%;
}

.searchForm {
  background: white;
  border-radius: 3px;
  padding: 0px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/operationCenter/clearingDetail.vue